import script from "./HrLegacySkeleton.vue?vue&type=script&setup=true&lang=js"
export * from "./HrLegacySkeleton.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__
import QSkeleton from 'quasar/src/components/skeleton/QSkeleton.js';
import qInstall from "../../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QSkeleton});
